import { Spacing } from '@persona-id/design-tokens';
import {
  ChangeEvent,
  Children,
  cloneElement,
  ComponentPropsWithoutRef,
  ReactElement,
  VFC,
} from 'react';
import styled, { css } from 'styled-components';

import Radio, { RadioProps } from 'design-system/components/Radio';
import useControlled from 'design-system/lib/useControlled';

const Container = styled.div<{ horizontal?: boolean }>`
  & > div {
    margin-bottom: ${Spacing[2]};
  }

  ${({ horizontal }) =>
    horizontal &&
    css`
      display: flex;
      align-items: center;
      & > div {
        margin-right: ${Spacing[2]};
      }
    `}
`;

export interface RadioGroupProps extends ComponentPropsWithoutRef<'div'> {
  defaultValue?: any;
  name?: string;
  value?: any;
  onChange?: (value: any) => void;
  /**
   * Direction of radio group
   */
  horizontal?: boolean;
}

const RadioGroup: VFC<RadioGroupProps> = ({
  children,
  defaultValue,
  name,
  value: valueProp,
  onChange,
  horizontal = false,
  ...elemProps
}) => {
  const [value, setValue] = useControlled({
    controlledValue: valueProp,
    default: defaultValue,
  });

  return (
    <Container role='radiogroup' horizontal={horizontal} {...elemProps}>
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      {Children.map(children, (child: ReactElement<RadioProps>) => {
        if (child?.type === Radio && (typeof valueProp !== 'undefined' || onChange)) {
          return cloneElement(child, {
            name,
            checked: child.props.value === value,
            onChange: (e: ChangeEvent<HTMLInputElement>) => {
              const newVal = e.target.value;
              if (typeof valueProp !== 'undefined' && onChange) {
                onChange(newVal);
              } else {
                setValue(newVal);
              }
            },
          });
        }

        if (name) {
          return cloneElement(child, { name });
        }

        return child;
      })}
    </Container>
  );
};

export default RadioGroup;
